import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

import { MoneySourceListService } from '../../service/money-source-list/money-source-list.service';

@Component({
	selector: 'app-money-source-list',
	templateUrl: './money-source-list.component.html',
	providers: [
		MoneySourceListService,
		HttpModule
	]
})
export class MoneySourceListComponent implements OnInit {

	private token;
	public moneySources: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	moneySource: FormGroup;

	constructor(fb: FormBuilder, private moneySourceListService: MoneySourceListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.moneySource = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchMoneySource(this.moneySource.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchMoneySource(this.moneySource.value, this.currentPage, false);
	}

	searchMoneySource(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.moneySourceListService.searchMoneySource(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.moneySources = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchMoneySource(this.moneySource.value, $event, false);
	}
}



// WEBPACK FOOTER //
// ./src/app/money-source/component/money-source-list/money-source-list.component.ts